/**
* @Description 文件功能说明：账户组件
* @Author
* @Time 2021/6/4
**/
<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;系统设置&ensp;&gt;&ensp;账户管理</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<RoleTree :roles="roles" :showBoxFlag="showTreeBoxFlag" @toggleBox="toggleTreeBox" @setSelectVal="setSelectVal" v-if="$store.getters.getUserRoleId=='1' || $store.getters.getUserRoleId=='2'"/>
		<AccountTable :roles="roles" :showTreeBoxFlag="showTreeBoxFlag" ref="accountTable"/>
    </div>
</template>

<script>
    import ApiRole from '@/request/api-role'
    import GlobalFun from '@/global/global-function'
    import RoleTree from '@/components_pages/Account/RoleTree'
    import AccountTable from '@/components_pages/Account/AccountTable'

    export default {
        /*
         * 组件名
         */
        name: "Account",
        /**
         * 引用组件
         * */
        components: {
            // 角色树组件
            RoleTree,
            // 账户表格组件
            AccountTable
        },
        /**
         * 数据定义
         * */
        data(){
            return {
                // 角色数据集合
                roles: [],
                // mini max tree box
                showTreeBoxFlag: false
            }
        },
        /**
         * 方法定义
         */
        methods:{
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
                // 跳转到 首页
                this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter
            // 查询角色
            searchRole() {
                this.$request.postJsonRequest(ApiRole.searchRolesApi).then(result => {
                    this.roles = GlobalFun.dataToTree(Object.assign([], result.rows), {
                        id: 'id',
                        pid: 'parentId',
                        children: 'children',
                        label: 'name',
                    });
                }).catch(error => {
                    console.error('查询角色异常', ApiRole.searchRolesApi, error);
                })
            },
            // 设置选中的值
            setSelectVal(val){
                if(val){
                    this.$refs['accountTable'].setSelectVal(val);
                }else{
                    this.$refs['accountTable'].setSelectVal();
                }
            },
            // 切换 tree box 状态
            toggleTreeBox(val) {
            	this.showTreeBoxFlag = val;
            },
            
        },// methods
        
        /**
         * 初始化加载
         */
        mounted() {
            if(this.$store.getters.getUserRoleId=='1' || this.$store.getters.getUserRoleId=='2'){
                // 查询角色
                this.searchRole();
                this.showTreeBoxFlag = true;
            }
        },// mounted
        
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/system/Account.vue